(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/settings-button.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/settings-button.js');
"use strict";

const CouponChoiceButton = svs.components.tipsen.couponChoiceButton.CouponChoiceButton;
const SettingsButton = _ref => {
  let ariaControls = _ref.ariaControls,
    onClick = _ref.onClick,
    isShowingSettings = _ref.isShowingSettings;
  return React.createElement(CouponChoiceButton, {
    ariaControls: ariaControls,
    ariaLabel: "Anpassa kupong",
    className: "coupon-toolbox-settings-button",
    icon: "settings",
    isAriaExpanded: isShowingSettings,
    isSelected: isShowingSettings,
    onClick: onClick
  }, "Anpassa");
};
setGlobal('svs.components.tipsen.couponChoiceButton.SettingsButton', SettingsButton);

 })(window);